// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation-module__navigation__+tiU4","menu":"Navigation-module__menu__WSBuV"};